import '@vebox/etui-system';
import { useState, useEffect, createElement, Fragment } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '@vebox/etui-colors';
import '../Spinner/Spinner.js';
import '../utils-fabc7ae7.js';
import 'react-dom';
import 'element-resize-detector';
import '../ContainerDimensions/ContainerDimensions.js';
import 'react-grid-layout';
import DashboardBase from './DashboardBase.js';
import DashboardContextProvider from './DashboardContext.js';
import './use-dashboard.js';

const _excluded = ["widgets"];
function DashboardStatic(_ref) {
  let {
      widgets
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [staticWidgets, setStaticWidgets] = useState(null);
  useEffect(() => {
    const updatedWidgets = widgets.map(widget => {
      widget.layout = _objectSpread2(_objectSpread2({}, widget.layout), {}, {
        static: true
      });
      widget.removable = false;
      widget.expandable = true;
      return widget;
    });
    setStaticWidgets(updatedWidgets);
  }, [widgets]);
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(DashboardContextProvider, null, /*#__PURE__*/createElement(DashboardBase, _extends({
    widgets: staticWidgets
  }, rest))));
}

export default DashboardStatic;
